import React from 'react';
import {
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	Heading,
	Stack,
	Tooltip,
} from '@chakra-ui/react';

import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { Education } from './education';
import { Experience } from './experience';
import { spouse } from '../data';
import { makeFields } from './utils';

export const Spouse = ({ state, setter, onBlur }) => {
	const {
		firstName,
		lastName,
		phoneNumber,
		email,
		birthDate,
		age,
		citizenship,
		residence,
		englishSkills,
		enCert,
		frenchSkills,
		frCert,
	} = makeFields(state, setter, spouse, onBlur);

	const spouseEducationSubState = state.education;
	const setSpouseEducation = education => {
		setter({ ...state, education });
	};
	const education = {
		state: spouseEducationSubState,
		setter: setSpouseEducation,
	};

	const spouseExperienceSubState = state.experience;
	const setSpouseExperience = experience => {
		setter({ ...state, experience });
	};
	const experience = {
		state: spouseExperienceSubState,
		setter: setSpouseExperience,
	};

	return (
		<Accordion>
			<AccordionItem>
				<h2>
					<AccordionButton>
						<Tooltip
							label="Основная информация о супруге"
							placement="top-start"
						>
							<Heading fontSize="lg" flex="1" textAlign="left">
								Spouse general information
							</Heading>
						</Tooltip>
						<AccordionIcon />
					</AccordionButton>
				</h2>
				<AccordionPanel pb={4}>
					<Stack direction={['column', 'row']}>
						<ProfileField pb={6} {...firstName} />
						<ProfileField pb={6} {...lastName} />
					</Stack>
					<Stack direction={['column', 'row']}>
						<ProfileField pb={6} {...phoneNumber} />
						<ProfileField pb={6} {...email} />
					</Stack>
					<Stack direction={['column', 'row']}>
						<ProfileField pb={6} {...birthDate} />
						<ProfileField pb={6} {...age} />
						<ProfileSelect pb={6} {...citizenship} />
						<ProfileSelect pb={6} {...residence} />
					</Stack>
					<Stack direction={['column', 'row']}>
						<ProfileSelect pb={6} {...englishSkills} />
						<ProfileField pb={6} {...enCert} />
					</Stack>
					<Stack direction={['column', 'row']}>
						<ProfileSelect pb={6} {...frenchSkills} />
						<ProfileField pb={6} {...frCert} />
					</Stack>
				</AccordionPanel>
			</AccordionItem>

			<AccordionItem>
				<h2>
					<AccordionButton>
						<Tooltip
							label="Послешкольное образование супруга (все вузы)"
							placement="top-start"
						>
							<Heading fontSize="lg" flex="1" textAlign="left">
								Spouse post-secondary education
							</Heading>
						</Tooltip>
						<AccordionIcon />
					</AccordionButton>
				</h2>
				<AccordionPanel pb={4}>
					<Education {...education} />
				</AccordionPanel>
			</AccordionItem>

			<AccordionItem>
				<h2>
					<AccordionButton>
						<Tooltip
							label="Опыт работы супруга за последние 10 лет"
							placement="top-start"
						>
							<Heading fontSize="lg" flex="1" textAlign="left">
								Spouse work experience
							</Heading>
						</Tooltip>
						<AccordionIcon />
					</AccordionButton>
				</h2>
				<AccordionPanel pb={4}>
					<Experience {...experience} />
				</AccordionPanel>
			</AccordionItem>
		</Accordion>
	);
};
